import {transaction} from "mobx";
import JSONWebToken from "../utils/JSONWebToken";
import {IView} from "./InterfaceStore";

export function hydrateStores(allStores, initialLookupData) {
    transaction(() => {
        if (initialLookupData.jwt) {
            const jwt = new JSONWebToken();
            const token = jwt.decode(initialLookupData.jwt);
            allStores.userStore.updateUser(token.user);
        }

        const previousView = allStores.interfaceStore.view;

        const currentOrganization = initialLookupData.currentOrganization;
        allStores.i18nStore.setLocaleByUrl(initialLookupData.locale);
        allStores.interfaceStore.setCurrentFullUrl(initialLookupData.currentFullUrl);
        allStores.interfaceStore.closeAllMenus();
        allStores.interfaceStore.setUserAgent(initialLookupData.userAgent);
        allStores.interfaceStore.setView(initialLookupData.view || IView.ERROR);

        if (initialLookupData.organization &&
            initialLookupData.organization.id !== allStores.organizationStore.organization.id) {
            allStores.organizationStore.buildOrganization(initialLookupData.organization);
            allStores.styleStore.updateStyles(initialLookupData.organization.json_data?.settings, currentOrganization, allStores.interfaceStore);
            allStores.i18nStore.setOrgDefaultLocale(initialLookupData.organization.json_data?.settings?.languages?.sourceLanguage);
            allStores.i18nStore.setOrganizationSupportedLocales(initialLookupData.organization.json_data?.settings?.languages?.targetLanguages);
        }

        const orgIdHasChanged = currentOrganization &&
            currentOrganization.id !== allStores.organizationStore.currentOrganization.id

        // perform these actions on page transitions and initial load, but not on query parameter changes
        if (orgIdHasChanged || ((previousView && initialLookupData.view) ? previousView !== initialLookupData.view : false)) {
            if (currentOrganization && currentOrganization.user_permissions) {
                allStores.userStore.setPermissions(currentOrganization.user_permissions);
            }
            allStores.modalStore.clearAllModals(); // clear modals so we remove any open modals before routing
            // sometimes we need data from an updated currentOrganization even when only the view has changed (i.e. schoolfeed)
            allStores.organizationStore.setCurrentOrganization(currentOrganization);
            if (allStores.interfaceStore.schoolFeedWidgetOpen) allStores.interfaceStore.toggleSchoolFeedWidgetOpen();

            if (initialLookupData.blocks) {
                allStores.gridStore.setBlocks(initialLookupData.blocks, true, initialLookupData.view === IView.ALPHA);

            }
        }

        /*
        When there is a locale in the URL, we can run into the situation where the i18nStore is instantiated, meaning
        googleCode is computed, but this method (updateApp) has not yet run. So when language logic is first run, there
        is no locale defined by URL which can result in issues. This ensures that we don't run any language logic until
        after we know we have the full context of the page.
         */
        allStores.i18nStore.setContextIsUpdated(true);
    })

    allStores.isHydrated = true;

    return allStores;
}